export default {
  Approved: 'Approved',
  Pending: 'Pending',
  Removed: 'Removed',
  Rejected: 'Rejected',
  Remove: 'Remove',
  Completed: 'Completed',
  Unmatched: 'Unmatched'
}
